<div class="flex-1 grow pr-large">
  <ng-container *ngIf="displayStrictPolicy">
    <h2 class="font-body-1">{{ 'dangerousGoods.fareRulesAndConditions.title' | finLocalization }}&nbsp;</h2>
    <p class="pr-xsmall-y">{{ 'dangerousGoods.fareRulesAndConditions.text' | finLocalization }}&nbsp;</p>
    <fcom-checkbox [name]="'i-accept'" [cid]="'i-accept'" [checked]="isConfirmed" (change)="confirmed.emit($event)">
      <span class="font-body-1 medium-type">{{ 'dialog.yesIAccept' | finLocalization }}</span>
    </fcom-checkbox>
    <h2 class="font-body-1 pr-xsmall-y">
      {{ 'dangerousGoods.termsAndConditionsBlock.title' | finLocalization }}
    </h2>
    <p id="dangerous-table-title-strict">
      {{ 'dangerousGoods.termsAndConditionsBlock.text' | finLocalization }}&nbsp;
      <ng-container *ngIf="dangerousGoodsLinks$ | async as dangerousGoodsLinks">
        <a
          class="font-body-1 nordic-blue-900-text"
          [finLink]="dangerousGoodsLinks.seeConditionsLink.url"
          [external]="true"
          [attr.target]="'_blank'"
          >{{ 'dangerousGoods.seeConditions' | finLocalization }}
          <fcom-icon name="external-tab" class="icon-medium"></fcom-icon>
        </a>
      </ng-container>
    </p>
  </ng-container>
  <ng-container *ngIf="!displayStrictPolicy">
    <p>
      {{ 'dangerousGoods.termsAndConditions' | finLocalization }}&nbsp;
      <ng-container *ngIf="dangerousGoodsLinks$ | async as dangerousGoodsLinks">
        <a
          class="font-body-1 nordic-blue-900-text"
          [finLink]="dangerousGoodsLinks.seeConditionsLink.url"
          [external]="true"
          [attr.target]="'_blank'"
          >{{ 'dangerousGoods.seeConditions' | finLocalization }}
          <fcom-icon name="external-tab" class="icon-medium"></fcom-icon>
        </a>
      </ng-container>
    </p>
    <p id="dangerous-table-title" class="medium-type pr-xsmall-y">{{ 'dangerousGoods.subtitle' | finLocalization }}</p>
  </ng-container>
  <div class="flex">
    <div class="flex-1 flex--basis0">
      <table
        class="font-body-1"
        [attr.aria-describedby]="!displayStrictPolicy ? 'dangerous-table-title' : 'dangerous-table-title-strict'"
      >
        <tr class="is-vishidden">
          <th scope="col">{{ 'dangerousGoods.table.title.icon' | finLocalization }}</th>
          <th scope="col">{{ 'dangerousGoods.table.title.rule' | finLocalization }}</th>
        </tr>
        <tr>
          <td>
            <fcom-icon name="lighters-matches" class="icon-large"></fcom-icon>
          </td>
          <td>{{ 'dangerousGoods.lightersAndMatches' | finLocalization }}</td>
        </tr>
        <tr>
          <td>
            <fcom-icon name="power-bank" class="icon-large"></fcom-icon>
          </td>
          <td>{{ 'dangerousGoods.powerBanks' | finLocalization }}</td>
        </tr>
        <tr>
          <td>
            <fcom-icon name="fire-arms-prohibited" class="icon-large"></fcom-icon>
          </td>
          <td>{{ 'dangerousGoods.firearms' | finLocalization }}</td>
        </tr>
        <tr>
          <td>
            <fcom-icon name="sharp-objects-prohibited" class="icon-large"></fcom-icon>
          </td>
          <td>{{ 'dangerousGoods.sharpObjects' | finLocalization }}</td>
        </tr>
      </table>

      <ng-container *ngIf="dangerousGoodsLinks$ | async as dangerousGoodsLinks">
        <a
          class="font-body-1 bold-type no-underline pr-xsmall-y nordic-blue-900-text"
          [finLink]="dangerousGoodsLinks.fullListOfRestrictedItemsLink.url"
          [external]="true"
          [attr.target]="'_blank'"
        >
          {{ 'dangerousGoods.fullListOfRestrictedItems' | finLocalization }}
          <fcom-icon name="external-tab" class="icon-medium"></fcom-icon>
        </a>
      </ng-container>
    </div>
  </div>
</div>
